module.exports = __webpack_public_path__ + "static/media/search-web.4ba1fbda.svg";